export const GET_PLC_SAFETY_CAUSES = 'GET_PLC_SAFETY_CAUSES';
export const GET_PLC_SAFETY_CAUSES_SUCCESS = 'GET_PLC_SAFETY_CAUSES_SUCCESS';
export const GET_PLC_SAFETY_CAUSES_ERROR = 'GET_PLC_SAFETY_CAUSES_ERROR';
